import React from 'react';
import Grid from '@mui/material/GridLegacy';
import { Box, Typography, Button, Card, CardContent, CardActions, Chip } from '@mui/material';
import { Add, Edit, Delete, LocalOffer } from '@mui/icons-material';

export default function TagsTab({
  tags,
  onAddTag,
  onEditTag,
  onDeleteTag,
}) {
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.primary' }}>
          Tags Management
        </Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={onAddTag}
          sx={{
            background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
            boxShadow: '0 4px 15px rgba(168, 85, 247, 0.4)',
            '&:hover': {
              background: 'linear-gradient(135deg, #ec4899 0%, #a855f7 100%)',
              boxShadow: '0 6px 20px rgba(168, 85, 247, 0.5)',
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.3s ease',
          }}
        >
          Add New Tag
        </Button>
      </Box>

      {!tags?.length ? (
        <Card
          sx={{
            p: 6,
            textAlign: 'center',
            borderRadius: 3,
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
            border: '1px solid rgba(0, 0, 0, 0.05)',
          }}
        >
          <LocalOffer sx={{ fontSize: 64, color: 'text.secondary', mb: 2, opacity: 0.5 }} />
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No tags yet
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Add tags to use as Primary Tag, Famous Tag, and Vibe Tags on places.
          </Typography>
        </Card>
      ) : (
        <Grid container spacing={3}>
          {tags.map((tag) => (
            <Grid item xs={12} sm={6} md={4} key={tag._id}>
              <Card
                sx={{
                  height: '100%',
                  borderRadius: 3,
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                  border: '1px solid rgba(0, 0, 0, 0.05)',
                  transition: 'all 0.3s ease',
                  overflow: 'hidden',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
                  },
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Box
                      sx={{
                        width: 48,
                        height: 48,
                        mr: 2,
                        bgcolor: 'rgba(168, 85, 247, 0.2)',
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'primary.main',
                      }}
                    >
                      <LocalOffer />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                        {tag.name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
                        {tag.slug}
                      </Typography>
                      <Chip
                        label={tag.isActive ? 'Active' : 'Inactive'}
                        size="small"
                        sx={{
                          mt: 1,
                          bgcolor: tag.isActive ? 'rgba(46, 125, 50, 0.1)' : 'rgba(158, 158, 158, 0.1)',
                          color: tag.isActive ? 'success.main' : 'text.secondary',
                          fontWeight: 500,
                        }}
                      />
                    </Box>
                  </Box>
                  {tag.description && (
                    <Typography color="text.secondary" sx={{ mb: 2, fontSize: '0.9rem' }}>
                      {tag.description}
                    </Typography>
                  )}
                </CardContent>
                <CardActions sx={{ p: 2, pt: 0, gap: 1 }}>
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={<Edit />}
                    onClick={() => onEditTag(tag)}
                    sx={{ flex: 1, borderRadius: 2, textTransform: 'none', fontWeight: 500 }}
                  >
                    Edit
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    color="error"
                    startIcon={<Delete />}
                    onClick={() => onDeleteTag(tag)}
                    sx={{ flex: 1, borderRadius: 2, textTransform: 'none', fontWeight: 500 }}
                  >
                    Delete
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}
